import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { navLinks } from "../../navLinks";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

const usePageNavbar = () => {
  const [activeNavLinkId, setActiveNavLinkId] = useState();
  const location = useLocation();
  const screens = useBreakpoint();

  const getNavLinkClassName = useCallback(
    ({ isActive }) => (isActive ? "active" : ""),
    []
  );

  const getActiveNavLinkId = useCallback(
    () => navLinks.find((navLink) => navLink.path === location.pathname).id,
    [location.pathname]
  );

  useEffect(() => {
    setActiveNavLinkId(getActiveNavLinkId());
  }, [getActiveNavLinkId]);

  return { getNavLinkClassName, activeNavLinkId, screens };
};

export default usePageNavbar;
